
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlarm as ObiAlarmElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alarm.js';
 
 
 

 
 export const ObiAlarm = createComponent({
   react: React,
   tagName: 'obi-alarm',
   elementClass: ObiAlarmElement,
   events: {
     
   }
  });
 
 